export var DELETE_ACCOUNT_FOR_LIST_STATE = /*#__PURE__*/function (DELETE_ACCOUNT_FOR_LIST_STATE) {
  DELETE_ACCOUNT_FOR_LIST_STATE["SUCCESS"] = "SUCCESS";
  DELETE_ACCOUNT_FOR_LIST_STATE["MAIN_SUCCESS_SECOND_FAIL"] = "MAIN_SUCCESS_SECOND_FAIL";
  DELETE_ACCOUNT_FOR_LIST_STATE["MAIN_FAIL_SECOND_SUCCESS"] = "MAIN_FAIL_SECOND_SUCCESS";
  DELETE_ACCOUNT_FOR_LIST_STATE["FAIL"] = "FAIL";
  DELETE_ACCOUNT_FOR_LIST_STATE["NOT_EXIST"] = "NOT_EXIST";
  return DELETE_ACCOUNT_FOR_LIST_STATE;
}({}); // 账号ID不存在在列表中
export var IBindQQStatus = /*#__PURE__*/function (IBindQQStatus) {
  IBindQQStatus["BIND_CGI_SUCCESS"] = "BIND_CGI_SUCCESS";
  IBindQQStatus["CHECK_KEY_IS_READY"] = "CHECK_KEY_IS_READY";
  IBindQQStatus["BIND_POLLING_RUNNING"] = "BIND_POLLING_RUNNING";
  IBindQQStatus["BIND_POLLING_FINISH"] = "BIND_POLLING_FINISH";
  IBindQQStatus["BIND_TIMEOUT"] = "BIND_TIMEOUT";
  IBindQQStatus["ERROR"] = "ERROR";
  return IBindQQStatus;
}({});

/**
 * 二次密码信息
 */

/**
 * 获取验证码
 */

/**
 * pwdVerifyCodeGet 入参
 */

/**
 * addPwd 入参
 */

/**
 * 添加或重置密码的返回
 */

/**
 * pwdReset 入参
 */

/**
 * pwdVerifyCodeCheck 入参
 */

/**
 * pwdQuestionCheck 入参
 */

/**
 * delPwd 入参
 */

/**
 * pwdVerify 入参
 */

/**
 * 用户是否可访问该文档
 */
export var IPermissionLevel = /*#__PURE__*/function (IPermissionLevel) {
  IPermissionLevel[IPermissionLevel["CAN_NOT_VIEW"] = 0] = "CAN_NOT_VIEW";
  IPermissionLevel[IPermissionLevel["CAN_VIEW"] = 1] = "CAN_VIEW";
  return IPermissionLevel;
}({});

/**
 * 帐户信息
 */

/**
 * @description b端的账号列表里存在两种数据结构 IBDomainAccountListItem 来自b端已登录账号列表
 * ICDomainAccountListItem来自c端已登录账号列表 使用fromDomain进行区分
 **/
//# sourceMappingURL=account.js.map